
<div>
    <b-modal
        title="Spara manuskript"
        size="lg"
        hide-footer
        @show="show"
        @hide="hide"
        ref="savemanuscript"
        id="savemanuscript"
    >
        <form @submit.prevent="onSubmit" inline autocomplete="off">
            <b-form-input
                required
                v-model="form.title"
                autofocus
                placeholder="Titel..."
                type="text"
            />
            <b-form-input v-model="form.id" hidden />
            <div class="float-right">
                <b-button variant="danger" type="reset" @click="hide"
                    >Avbryt</b-button
                >
                <b-button variant="primary" type="submit">Spara</b-button>
            </div>
            <div v-if="id != 'new'">
                <b-row>
                    <b-col cols="1">
                        <b-form-checkbox v-model="createNew" />
                    </b-col>
                    <b-col cols="7">Spara nytt manuskript</b-col>
                </b-row>
            </div>
        </form>
    </b-modal>
</div>
